import { Route } from 'react-router-dom';
import Dashboard from './index';
// Import de ConnectionPage eliminado ya que no se usa la ruta
// import ConnectionPage from './pages/ConnectionPage';

export const DashboardRoutes = [
  <Route key="dashboard" path="/dashboard" element={<Dashboard />} />,
  // Ruta para ConnectionPage eliminada
  // <Route key="connection" path="/dashboard/connection" element={<ConnectionPage />} />
];